import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import React, { useEffect, useState } from "react";
import QuickAddNewExpenseItem from "../userExpense/expenseItemMaster";
import { Loader } from "@progress/kendo-react-indicators";

const ExpenseAddItemTable = ({ callBack, categoryItemArray, selectedItemArray, isConvert, isEditMode, callBackNewAddItem, isSaleType }) => {
    const [businessSetting, setBusinessSetting] = useState({});
    const [companyId, setCompanyId] = useState(0);
    const [businessId, setBusinessId] = useState(0);
    const [companyLogo, setCompanyLogo] = useState('');
    const [totalQuantity, setTotalQuantity] = useState(0);
    const [totalFreeQuantity, setTotalFreeQuantity] = useState(0);
    const [totalAdditionalCess, setTotalAdditionalCess] = useState(0);
    const [totalDiscount, setTotalDiscount] = useState(0);
    const [totalGstAmount, setTotalGstAmount] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [unitDataArray, setUnitDataArray] = useState([]);
    const [taxTypeDataArray, setTaxTypeDataArray] = useState([]);
    const [taxRateDataArray, setTaxRateDataArray] = useState([]);
    const [itemRows, setItemRows] = useState([]);
    const [itemList, setItemList] = useState([]);
    const [selectedItem, setSelectedItem] = useState({});
    const [selectedItemIndex, setSelectedItemIndex] = useState(-1);
    const [isPurchasePriceShow, setIsPurchasePriceShow] = useState(0);
    const [isDialog_ItemList, setIsDialog_ItemList] = useState(false);
    const [isDialog_AddNewItem, setIsDialog_AddNewItem] = useState(false);
    const [searchItemName, setSearchItemName] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setItemList(categoryItemArray);
        const _taxRateDataArray = [{ value: "With Tax", label: "With Tax" },
        { value: "Without Tax", label: "Without Tax" }]
        setTaxTypeDataArray(_taxRateDataArray);

        setItemRows(selectedItemArray);
        calculateTotalTableAmount(selectedItemArray);
    }, [categoryItemArray, selectedItemArray]);

    useEffect(() => {
        let _UserSession = localStorage.getItem("vs_UserSession");

        if (_UserSession != undefined || _UserSession != null) {
            if (_UserSession.loginType != "Admin") {
                _UserSession = JSON.parse(_UserSession);
                let _signingId = _UserSession.loginId;
                let _businessId = _UserSession.tokenKey;
                let _company_id = _UserSession.company_id;
                let _businessSetting = _UserSession.businessSetting;

                setCompanyId(_company_id);
                setBusinessId(_businessId);
                // Clone before zeroing — see SaleAddItemTable.js for the full
                // rationale. Mutating the parsed session's businessSetting in
                // place can leak the zeros back to localStorage on the next
                // stringify and disable the user's real Company Settings choices.
                if(!isSaleType){
                    _businessSetting = { ..._businessSetting };
                    _businessSetting.SerialNoChk = 0;
                    _businessSetting.SerialNoAdditionalChk1 = 0;
                    _businessSetting.SerialNoAdditionalChk2 = 0;
                    _businessSetting.BatchNoChk = 0;
                    _businessSetting.ModelNoChk = 0;
                    _businessSetting.ExpDateChk = 0;
                    _businessSetting.MfgDateChk = 0;
                    _businessSetting.SizeChk = 0;
                    _businessSetting.BatchNoAdditionalChk1 = 0;
                    _businessSetting.BatchNoAdditionalChk2 = 0;
                }
                setBusinessSetting(_businessSetting);
                setIsPurchasePriceShow(_businessSetting.DisplayPurchasePrice);
            }
        }
        let _companySession = localStorage.getItem("vs_UserCompanySession");
        if (_companySession != undefined || _companySession != null) {
            _companySession = JSON.parse(_companySession);
            let _businessId = _companySession.business_id;
            let _company_id = _companySession.company_id;
            let _countryCode = _companySession.country_code;
            let _countryName = _companySession.country_name;
            let _taxRateArray = _companySession.taxDetails;
            let _company_Logo = _companySession.company_logo;

            setCompanyId(_company_id);
            setBusinessId(_businessId);
            setCompanyLogo('https://www.vyavsay.in/websiteFilesFolder/img/vyavsay.png');
            getUnitData(_businessId,_company_id);
            _taxRateArray.push({ id: 0, name: 'None', ratio: 0 });
            setTaxRateDataArray(_taxRateArray);
        }
    }, []);

    const handleKeyPress = (e) => {
        if (!/[0-9]/.test(e.key)) {
            e.preventDefault();
        }
    };

    const getUnitData = async (businessId,companyId) => {
        let _unitData = await fetch(
            global.userUnitList + `?business_id=${businessId}&company_id=${companyId}`
        );
        _unitData = await _unitData.json();
        if (_unitData.response) {
            _unitData = _unitData.response;
            setUnitDataArray(_unitData);
        }

    }

    const itemListFilter = itemList.filter(item =>
        item.name.toLowerCase().includes(searchItemName.toLowerCase())
    );
    const addItemRow = () => {
        const newRow = {
            item_id: 0,
            quantity: 0,
            free_quantity: 0,
            discount_in_per: 0,
            discount_in_amount: 0,
            tax_value: 0,
            total_amount: 0,
            tax_rate_id: 0,
            rate: 0,
            sale_tax_type: 'Without Tax',
        };
        setItemRows([...itemRows, newRow]);
    };
    const deleteItemRow = (deleteIndex) => {
        const deletedRow = itemRows.find((data, index) => index === deleteIndex);

        let updatedItemRows = itemRows.map((data, index) => {
            if (data.trackingType == 'Serial') {
                let itemSerialNo = data.itemSerialNo;
                if (deletedRow.selectedData != undefined) {
                    let deletedSerialNo = deletedRow.selectedData.map((data) => ({
                        ...data,
                        isSelected: false,
                    }));
                    if(!deletedSerialNo[0].isNewItem){
                        itemSerialNo.push(...deletedSerialNo);
                    }
                }

                return ({
                    ...data,
                    itemSerialNo: data.item_id == deletedRow.item_id ? itemSerialNo : data.itemSerialNo,
                })
            } else if (data.trackingType == 'Batch') {
                let itemBatchNo = data.itemBatchNo;
                if (deletedRow.selectedData != undefined) {
                    let deletedBatchNo = deletedRow.selectedData.map((data) => ({
                        ...data,
                        opening_stock: parseInt(data.opening_stock) + parseInt(data.free_quantity) + parseInt(data.used_stock),
                        free_quantity: 0,
                        used_stock: 0
                    }));
                    //itemBatchNo.push(...deletedBatchNo);
                }
                return ({
                    ...data,
                    itemBatchNo: data.item_id == deletedRow.item_id ? itemBatchNo : data.itemBatchNo,
                })
            } else {
                let qty = deletedRow.quantity + deletedRow.free_quantity;
                return ({
                    ...data,
                    quantity: data.item_id == deletedRow.item_id ? qty : data.quantity,
                })
            }
        })
        let rows = updatedItemRows.filter((data, index) => index !== deleteIndex);

        setItemRows(rows);
        calculateTotalTableAmount(rows);

        let updateItemList = itemList.map((data) => {
            if (deletedRow.trackingType == 'Serial') {
                let itemSerialNo = data.itemSerialNo;
                if (data.item_id == deletedRow.item_id) {
                    if (deletedRow.selectedData != undefined) {
                        let deletedSerialNo = deletedRow.selectedData.map((data) => ({
                            ...data,
                            isSelected: false,
                        }));
                        if(!deletedSerialNo[0].isNewItem){
                            itemSerialNo.push(...deletedSerialNo);
                        }
                        
                    }
                }

                return ({
                    ...data,
                    itemSerialNo: itemSerialNo,
                })
            } else if (deletedRow.trackingType == 'Batch') {
                let itemBatchNo = data.itemBatchNo;
                if (deletedRow.selectedData != undefined) {
                    let deletedBatchNo = deletedRow.selectedData.map((data) => ({
                        ...data,
                        opening_stock: parseInt(data.opening_stock) + parseInt(data.free_quantity) + parseInt(data.used_stock),
                        free_quantity: 0,
                        used_stock: 0
                    }));
                    if (itemBatchNo.filter((data) => data.batch_id == deletedBatchNo[0].batch_id).length > 0) {

                        if (!deletedBatchNo[0].isNewItem) {
                            itemBatchNo = itemBatchNo.map((data) => ({
                                ...data,
                                opening_stock: data.batch_id == deletedBatchNo[0].batch_id ? (parseInt(data.opening_stock) + parseInt(data.free_quantity) + parseInt(data.used_stock)) : data.opening_stock
                            }))
                        } else {

                        }

                    } else if (data.item_id == deletedRow.item_id) {
                        itemBatchNo.push(...deletedBatchNo);
                    }

                }
                return ({
                    ...data,
                    itemBatchNo: data.item_id == deletedRow.item_id ? itemBatchNo : data.itemBatchNo,
                })
            } else {
                let qty = deletedRow.quantity + deletedRow.free_quantity;
                return ({
                    ...data,
                    quantity: data.item_id == deletedRow.item_id ? qty : data.quantity,
                })
            }
        })
        setItemList(updateItemList);
    };

    const showItemList = (index) => {
        setSelectedItemIndex(index);
        setIsDialog_ItemList(true);
    }

    const onChangeQuantity = (value, index) => {
        value = parseFloat(value) || 0;
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(data.sale_tax_type, data.tax_rate_id, data.rate);
                let sub_total_amount = (value * price);
                let discount_in_per = parseFloat(data.discount_in_per) || 0;
                let discount_in_amount = (discount_in_per * sub_total_amount) / 100;
                discount_in_amount = parseFloat(discount_in_amount.toFixed(2));

                let total_amount = sub_total_amount - discount_in_amount;
                let taxRate = taxRateDataArray.find(tax => tax.id == data.tax_rate_id) || { ratio: 0 };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                return {
                    ...data,
                    quantity: value,
                    tax_value: taxValue,
                    total_amount: total_amount,
                    subtotal: sub_total_amount,
                    discount_in_per: discount_in_per,
                    discount_in_amount: discount_in_amount,
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }

    const onChangeRate = (value, index) => {
        value = parseFloat(value) || 0;
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(data.sale_tax_type, data.tax_rate_id, value);
                let sub_total_amount = (data.quantity * price);
                let discount_in_per = parseFloat(data.discount_in_per) || 0;
                let discount_in_amount = (discount_in_per * sub_total_amount) / 100;
                discount_in_amount = parseFloat(discount_in_amount.toFixed(2));
                let total_amount = sub_total_amount - discount_in_amount;
                let taxRate = taxRateDataArray.find(tax => tax.id == data.tax_rate_id) || { ratio: 0 };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                return {
                    ...data,
                    rate: value,
                    tax_value: taxValue,
                    total_amount: total_amount,
                    subtotal: sub_total_amount,
                    discount_in_per: discount_in_per,
                    discount_in_amount: discount_in_amount
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }
    const onChangeTaxType = (value, index) => {
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(value, data.tax_rate_id, data.rate);
                let sub_total_amount = (data.quantity * price);
                let discount_in_per = parseFloat(data.discount_in_per) || 0;
                let discount_in_amount = (discount_in_per * sub_total_amount) / 100;
                discount_in_amount = parseFloat(discount_in_amount.toFixed(2));
                let total_amount = sub_total_amount - discount_in_amount;
                let taxRate = taxRateDataArray.find(tax => tax.id == data.tax_rate_id) || { id: 0, ratio: 0, name: 'None' };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                return {
                    ...data,
                    sale_tax_type: value,
                    tax_rate_id: taxRate.id,
                    tax_value: taxValue,
                    tax_type: taxRate,
                    discount_in_per: discount_in_per,
                    discount_in_amount: discount_in_amount,
                    total_amount: total_amount,
                    subtotal: sub_total_amount
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }
    const onChangeDiscountPercentage = (value, index) => {
        value = parseFloat(value) || 0;
        if (value > 100) {
            alert('Discount percentage cannot be greater than 100.');
            return;
        }
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(data.sale_tax_type, data.tax_rate_id, data.rate);
                let sub_total_amount = (data.quantity * price);
                let discount_in_amount = (value * sub_total_amount) / 100;
                discount_in_amount = parseFloat(discount_in_amount.toFixed(2));
                let total_amount = (sub_total_amount - discount_in_amount);
                let taxRate = taxRateDataArray.find(tax => tax.id == data.tax_rate_id) || { ratio: 0 };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                return {
                    ...data,
                    discount_in_per: value,
                    discount_in_amount: discount_in_amount,
                    tax_value: taxValue,
                    total_amount: total_amount,
                    subtotal: sub_total_amount
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }
    const onChangeDiscountAmount = (value, index) => {
        value = parseFloat(value) || 0;
        if (value > (itemRows[index].quantity * itemRows[index].rate)) {
            alert('Discount amount cannot be greater than total amount.');
            return;
        }
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(data.sale_tax_type, data.tax_rate_id, data.rate);
                let sub_total_amount = (data.quantity * price);
                let discount_in_per = sub_total_amount === 0 ? 0 : ((value / sub_total_amount) * 100);
                let total_amount = (sub_total_amount - value);
                let taxRate = taxRateDataArray.find(tax => tax.id == data.tax_rate_id) || { ratio: 0 };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                return {
                    ...data,
                    discount_in_per: parseFloat(discount_in_per.toFixed(2)),
                    discount_in_amount: value,
                    tax_value: taxValue,
                    total_amount: total_amount,
                    subtotal: sub_total_amount
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }
    const onChangeTaxRate = (value, index) => {
        let data = itemRows.map((data, i) => {
            if (i == index) {
                let price = getPriceWithTaxWithOutTax(data.sale_tax_type, value, data.rate);
                let sub_total_amount = (data.quantity * price);
                let discount_in_per = parseFloat(data.discount_in_per) || 0;
                let discount_in_amount = (discount_in_per * sub_total_amount) / 100;
                let total_amount = (sub_total_amount - discount_in_amount);
                let taxRate = taxRateDataArray.find(tax => tax.id == value) || { id: 0, ratio: 0, name: 'None' };
                let taxValue = (taxRate.ratio * total_amount) / 100;
                taxValue = parseFloat(taxValue.toFixed(2));
                total_amount += taxValue;
                total_amount = parseFloat(total_amount.toFixed(2));
                discount_in_amount = parseFloat(discount_in_amount.toFixed(2));
                return {
                    ...data,
                    tax_rate_id: value,
                    tax_value: taxValue,
                    tax_type: taxRate,
                    discount_in_per: discount_in_per,
                    discount_in_amount: discount_in_amount,
                    total_amount: total_amount,
                    subtotal: sub_total_amount
                }
            } else {
                return data;
            }
        })
        setItemRows(data);
        calculateTotalTableAmount(data);
    }
    function calculateDiscount(discount_type, discount_in_price, quantity, free_quantity, rate) {
        let discount_in_per = 0;
        let discount_in_amount = 0;
        discount_in_price = parseFloat(discount_in_price) || 0;
        quantity = parseFloat(quantity) || 0;
        rate = parseFloat(rate) || 0;

        if (discount_type === "Percentage") {
            discount_in_amount = (discount_in_price * ((quantity) * rate)) / 100;
            discount_in_per = discount_in_price;
        } else {
            discount_in_amount = parseFloat(discount_in_price);
            let totalPrice = (quantity) * rate;
            discount_in_per = totalPrice === 0 ? 0 : (discount_in_price / totalPrice) * 100;
        }
        discount_in_amount = parseFloat(discount_in_amount.toFixed(2));
        discount_in_per = parseFloat(discount_in_per) || 0;
        return { discount_in_per, discount_in_amount };
    }
    const getPriceWithTaxWithOutTax = (sale_tax_type, tax_rate_id, price) => {
        price = parseFloat(price) || 0;
        if (taxRateDataArray.length > 0) {
            let taxRate = taxRateDataArray.find(tax => tax.id == tax_rate_id);
            if (taxRate && sale_tax_type == 'With Tax') {
                // taxRate.ratio comes back from vs_admin_gst.ratio as a STRING; without coercion the `+` concatenates ("100" + "0" → "1000") and price collapses to 1/10th.
                price = (price / (100 + Number(taxRate.ratio))) * 100;
            }
        }
        return parseFloat(price).toFixed(2);
    }
    const updateItemRowData = (itemList, newData, isFreeQuantity) => {
        let updatedData = itemRows;
        updatedData[selectedItemIndex] = newData;
        let qty = parseFloat(newData.quantity) || 0;

        let price = getPriceWithTaxWithOutTax(newData.sale_tax_type, newData.tax_rate_id, newData.rate);

        const { discount_in_per, discount_in_amount } = calculateDiscount(newData.discount_type, newData.discount_in_sale_price, qty, newData.free_quantity, price);
        let sub_total_amount = (qty * price);
        let total_amount = (sub_total_amount - discount_in_amount);
        let taxRate = taxRateDataArray.find(tax => tax.id == newData.tax_rate_id) || { ratio: 0 };
        let taxValue = (taxRate.ratio * total_amount) / 100;
        taxValue = parseFloat(taxValue.toFixed(2));
        total_amount += taxValue;
        total_amount = parseFloat(total_amount.toFixed(2));
        updatedData = updatedData.map((data, index) => {
            if (data.item_id == newData.item_id) {
                return {
                    ...data,
                    quantity: qty,
                    discount_in_per: selectedItemIndex == index ? discount_in_per : data.discount_in_per,
                    discount_in_amount: selectedItemIndex == index ? discount_in_amount : data.discount_in_amount,
                    tax_value: selectedItemIndex == index ? taxValue : data.tax_value,
                    total_amount: selectedItemIndex == index ? total_amount : data.total_amount,
                    subtotal: selectedItemIndex == index ? sub_total_amount : data.subtotal,
                }

            } else {
                return data;
            }
        });
        
        setItemRows(updatedData);
        calculateTotalTableAmount(updatedData);
        setSelectedItem({});
        setSelectedItemIndex(-1);
        //updateMainItemData(itemList, newData, isFreeQuantity);
    }
    
    const calculateTotalTableAmount = (updatedData) => {
        const totalQuantity = updatedData.map((data) => parseFloat(data.quantity) || 0).reduce((acc, quantity) => acc + quantity, 0);
        setTotalQuantity(totalQuantity);

        const totalFreeQuantity = updatedData.map((data) => parseFloat(data.free_quantity) || 0).reduce((acc, free_quantity) => acc + free_quantity, 0);
        setTotalFreeQuantity(totalFreeQuantity);

        const totalDiscount = updatedData.map((data) => parseFloat(data.discount_in_amount) || 0).reduce((acc, discount_in_amount) => acc + discount_in_amount, 0);
        setTotalDiscount(totalDiscount);

        const totalGstAmount = updatedData.map((data) => parseFloat(data.tax_value) || 0).reduce((acc, tax_value) => acc + tax_value, 0);
        setTotalGstAmount(parseFloat(totalGstAmount.toFixed(2)));

        const totalAmount = updatedData.map((data) => { return parseFloat(data.total_amount) || 0; }).reduce((acc, total_amount) => acc + total_amount, 0);
        setTotalAmount(parseFloat(totalAmount.toFixed(2)));

        let itemSubTotalAmount = updatedData.map((data) => { return (parseFloat(data.quantity) || 0) * getPriceWithTaxWithOutTax(data.sale_tax_type, data.tax_rate_id, data.rate); }).reduce((acc, sub_total_amount) => acc + sub_total_amount, 0);
        itemSubTotalAmount = parseFloat(itemSubTotalAmount.toFixed(2));

        callBack(updatedData, totalAmount, (totalQuantity + totalFreeQuantity), itemSubTotalAmount);
    }
    
    const selectItemData = (items, rowIndex) => {
        const updatedData = itemRows.map((item, i) => {
            if (i == rowIndex) {
                return { ...item, ...items };
            }
            return item;
        });
        setItemRows(updatedData);
        setSelectedItem(items);
        setIsDialog_ItemList(false);
        updateItemRowData(itemList, items, false);
    }
   
    const listStyle = {
        listStyleType: 'none',
        padding: 0,
        margin: 0,
    };

    const itemStyle = {
        padding: '10px',
        margin: '5px 0',
        border: '2px solid #ccc',
        borderRadius: '5px',
        transition: 'border-color 0.3s ease',
    };

    const handleItemSearchChange = (e) => {
        setSearchItemName(e.target.value);
    }

   

    const viewItemList = (rowIndex) => {
        return (
            itemListFilter.length > 0 ?
                itemListFilter.map((items, index) => {
                    let urlImg = companyLogo;

                    return (
                        <li
                            key={index}
                            style={itemStyle}
                            onMouseEnter={(e) => (e.target.style.borderColor = '#673ab7')}
                            onMouseLeave={(e) => (e.target.style.borderColor = '#ccc')}
                            onClick={() => selectItemData(items, rowIndex)}
                        >
                            <img src={urlImg} style={{ maxWidth: '30px', maxHeight: '30px', borderRadius: '10px', marginRight: 20 }} />

                            <span className="iti__party-name">
                                {items.name} <br />
                            </span>
                        </li>
                    );
                }) :
                <li>No item found</li>
        )
    }

    const viewItemTable = () => {
        let _dataSet = [];
        itemRows.map((item, index) => {

            _dataSet.push(
                <tr key={index} style={{ backgroundColor: "white" }}>
                    {!isConvert && <td>
                        <button
                            type="button"
                            onClick={() => {
                                deleteItemRow(index);
                            }}
                            className="btn btn-outline-danger"
                        >
                            X
                        </button>
                    </td>}
                    <td>{index + 1}</td>
                    <td  >
                        <div className="col-lg-12">
                            <div
                                className="form-material open"
                                id="paddingOff"
                                onMouseLeave={() => { }}
                            >
                                <input
                                    type="text"
                                    className="form-control search-box"
                                    onChange={() => { }}
                                    onClick={() => !item.name && showItemList(index)}
                                    placeholder="Item Name Here..."
                                    autoComplete="off"
                                    value={item.name}
                                    readOnly
                                />
                            </div>
                        </div>
                    </td>

                    <td>
                        <div className="col-lg-12 form-material" id="paddingOff">
                            <input
                                type="text"
                                required="required"
                                className="form-control"
                                value={item.quantity}
                                onChange={(e) => { onChangeQuantity(e.target.value, index) }}
                                disabled={isConvert}
                            />
                        </div>
                    </td>
                    
                    
                    <td>
                        <div className="col-lg-12 form-material" id="paddingOff">
                            <input
                                type="text"
                                min="0"
                                required="required"
                                className="form-control"
                                onKeyPress={(e) => handleKeyPress(e)}
                                value={item.rate}
                                onChange={(e) => { onChangeRate(e.target.value, index) }}
                                disabled={isConvert}
                            />
                        </div>
                    </td>
                    
                    {businessSetting.AllowInclusiveExclusive == 1 && (
                        <td>
                            <div className="col-lg-12 form-material" id="paddingOff">
                                <select
                                    style={{ width: "90px" }}
                                    className="form-control"
                                    value={item.sale_tax_type}
                                    onChange={(e) => { onChangeTaxType(e.target.value, index) }}
                                    disabled={isConvert}
                                >
                                    {taxTypeDataArray.map(({ value, label }, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={value}
                                            >
                                                {label}
                                            </option>
                                        );
                                    })}
                                </select>
                            </div>
                        </td>
                    )}

                    {businessSetting.ItemWiseDiscount == 1 && (
                        <td>
                            <tr style={{ backgroundColor: "white" }}>
                                <td>
                                    <div className="col-lg-12 form-material" id="paddingOff">
                                        <input
                                            type="text"
                                            style={{ width: "60px" }}
                                            min="0"
                                            maxLength="3"
                                            className="form-control"
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            value={item.discount_in_per}
                                            autoComplete="off"
                                            onChange={(e) => onChangeDiscountPercentage(e.target.value, index)}
                                            max="100"
                                            disabled={isConvert}
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="col-lg-12 form-material" id="paddingOff">
                                        <input
                                            type="text"
                                            min="0"
                                            maxLength="99999"
                                            className="form-control"
                                            onKeyPress={(e) => handleKeyPress(e)}
                                            value={item.discount_in_amount}
                                            autoComplete="off"
                                            onChange={(e) => onChangeDiscountAmount(e.target.value, index)}
                                            disabled={isConvert}
                                        />
                                    </div>
                                </td>
                            </tr>
                        </td>
                    )}
                    {businessSetting.ItemWiseTax == 1 && (
                        <td>
                            <tr style={{ backgroundColor: "white" }}>
                                <td>
                                    <div className="col-lg-12 form-material" id="paddingOff">
                                        <select
                                            style={{ width: "85px" }}
                                            className="form-control"
                                            onChange={(e) => { onChangeTaxRate(e.target.value, index) }}
                                            value={item.tax_rate_id}
                                            disabled={isConvert}
                                        >
                                            {taxRateDataArray.map((tax, index) => {

                                                return (
                                                    <option
                                                        key={index}
                                                        value={tax.id} >
                                                        {tax.name + (tax.id == 0 ? '' : "@" + tax.ratio + "%")}
                                                    </option>
                                                );
                                            })}
                                        </select>
                                    </div>
                                </td>
                                <td>
                                    <div className="col-lg-12 form-material" id="paddingOff">
                                        <input
                                            type="text"
                                            disabled={isConvert}
                                            min="0"
                                            maxLength="100"
                                            className="form-control demo1"
                                            value={item.tax_value}
                                            readOnly
                                        />
                                    </div>
                                </td>
                            </tr>
                        </td>
                    )}
                    <td>
                        <div className="col-lg-12 form-material" id="paddingOff">
                            <input
                                type="text"
                                readOnly
                                className="form-control"
                                value={item.total_amount}
                            />
                        </div>
                    </td>
                </tr>
            );
        });
        return _dataSet;
    }
    return (
        <div className="row">
            <div className="col-md-12" id="formSideItem">
                <div className="block block-transparent">
                    <div className="block-content" id="formSideItem">
                        <table className="table table-bordered table-striped table-vcenter">
                            <thead id="sideTable">
                                <tr>
                                    {(!isConvert && <th style={{ width: "30px" }}></th>)}
                                    <th style={{ width: "30px" }}>#</th>
                                    <th style={{ width: "200px", minWidth: "200px" }}>Item</th>
                                    <th style={{ width: "50px" }}>Qty</th>
                                    <th style={{ width: "150px" }}>Price / Unit</th>
                                    {businessSetting.AllowInclusiveExclusive == 1 && (
                                        <th style={{ width: "150px" }}> Tax Type </th>
                                    )}

                                    {businessSetting.ItemWiseDiscount == 1 && (
                                        <th style={{ width: "250px" }}>
                                            <tr>
                                                <td style={{ width: "194px" }} colSpan="2">
                                                    Discount
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "130px" }}>%</td>
                                                <td style={{ width: "100px" }}>Amount</td>
                                            </tr>
                                        </th>
                                    )}
                                    {businessSetting.ItemWiseTax == 1 && (
                                        <th style={{ width: "300px" }}>
                                            <tr>
                                                <td style={{ width: "194px" }} colSpan="2">
                                                    Tax
                                                </td>
                                            </tr>
                                            <tr>
                                                <td style={{ width: "50px" }}>%</td>
                                                <td style={{ width: "100px" }}>Amount</td>
                                            </tr>
                                        </th>
                                    )}
                                    <th style={{ width: "100px" }}>Amount</th>
                                </tr>
                            </thead>

                            <tbody id="sideTable">
                                {viewItemTable()}

                                {
                                    itemRows.length > 0 &&
                                    <tr>
                                        {(!isConvert && <td></td>)}
                                        <td></td>
                                        <td>
                                            <span
                                                style={{ float: 'left', fontWeight: 600, textTransform: "uppercase" }} >
                                                Total</span>
                                        </td>
                                        <td>
                                            <span
                                                style={{ float: 'left', fontWeight: 600 }} >
                                                {totalQuantity}
                                            </span>
                                        </td>
                                        <td></td>


                                        {businessSetting.AllowInclusiveExclusive == 1 && (
                                            <td></td>
                                        )}
                                        {businessSetting.ItemWiseDiscount == 1 && (
                                            <td>
                                                <span style={{ float: 'left', fontWeight: 600 }} >
                                                    {totalDiscount}
                                                </span>
                                            </td>
                                        )}

                                        {businessSetting.ItemWiseTax == 1 && (
                                            <td>
                                                <span style={{ float: 'left', fontWeight: 600 }} >
                                                    {totalGstAmount}
                                                </span>
                                            </td>
                                        )}

                                        <td>
                                            <span style={{ float: 'left', fontWeight: 600 }} >
                                                {totalAmount}
                                            </span>
                                        </td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                        {
                            !isConvert &&
                            <div>
                                <button
                                    className="badge badge-primary pull-left"
                                    onClick={() => { addItemRow() }}
                                >
                                    Add Items
                                </button>
                            </div>
                        }
                    </div>
                </div>
            </div>
            {
                isDialog_ItemList && (
                    <Dialog style={{ zIndex: 1040 }} width={500} height={600} title={'Items'} onClose={() => {
                        setIsDialog_ItemList(false);
                        deleteItemRow(selectedItemIndex);
                    }}>

                        <div style={{ marginBottom: '20px', display: 'flex', alignItems: 'center' }}>
                            <input
                                type="text"
                                placeholder="Search item name..."
                                value={searchItemName}
                                onChange={(e) => handleItemSearchChange(e)}
                                style={{ padding: '8px', fontSize: '16px', width: '450px', flexGrow: 1 }}
                            />
                            <button
                                type="submit"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={() => {
                                    setIsDialog_AddNewItem(true);
                                }}
                                style={{ padding: '12px 16px', fontSize: '16px', marginLeft: '10px' }}
                            >
                                <i className="si si-plus" style={{ marginRight: 10 }}></i>
                                Add New Item
                            </button>
                        </div>
                        <ul

                            style={listStyle}
                        >
                            {viewItemList(selectedItemIndex)}
                        </ul>

                    </Dialog>
                )
            }
            {
                isDialog_AddNewItem && (
                    <Dialog style={{ zIndex: 1050 }} width={1000} height={600} title={'Items'} onClose={() => setIsDialog_AddNewItem(false)}>

                        <QuickAddNewExpenseItem
                            callBack={(data) => {
                                let item = data[0];
                                let newItem = {
                                    ...item,
                                    rate: item.sale_price,
                                    quantity: 0,
                                    free_quantity: 0,
                                    trans_count: 0,
                                    discount_in_per: 0,
                                    discount_in_amount: 0,
                                    total_amount: 0,
                                    selectedData: []
                                }
                                setItemList(data);
                                callBackNewAddItem(data);
                                setIsDialog_AddNewItem(false);
                            }}
                            newItemId={0}
                            itemName={''}
                            itemCreateType="Sale"
                        />

                    </Dialog>
                )
            }
            
            {
                isLoading && (
                    <Dialog >
                        <Loader type="converging-spinner" />
                    </Dialog>
                )
            }
        </div>
    )
}
export default ExpenseAddItemTable